module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8619/img/website-performance-rating.jpg"